module.exports = __webpack_public_path__ + "static/media/photoshop.6115c8a9.svg";